<template>
  <component
    :is="tagName"
    class="baseButton"
    :class="[
      properties.variant,
      properties.size,
      {fullwidth: properties.fullwidth},
      {loader: loading},
      {[properties.attentionSeeker]: properties.attentionSeeker !== 'none'},
    ]"
  >
    <span class="text" v-bind="textProps">
      <BaseText
        :prop="[prop, 'text'].filter((e) => e).join('.')"
        :content="properties.text"
        :options="{
          singleLine: true,
          link: false,
        }"
      />

      <i
        v-if="properties.icon"
        class="c-icon"
        :class="`icon-${properties.icon}`"
      />
    </span>
    <span v-if="properties.subtext" class="subtext">
      <BaseText
        :prop="[prop, 'subtext'].filter((e) => e).join('.')"
        :content="properties.subtext"
        :options="{
          singleLine: true,
          link: false,
        }"
      />
    </span>
  </component>
</template>

<script>
export const createSelectors = ({name, label, selector}) => [
  {
    name: name,
    label: label,
    selector: `${selector}`,
  },
  {
    name: `${name}Icon`,
    label: `${label} Icon`,
    selector: `${selector} .c-icon`,
  },
  {
    name: `${name}Text`,
    label: `${label} Text`,
    selector: `${selector} .text`,
  },
  {
    name: `${name}Subtext`,
    label: `${label} Subtext`,
    selector: `${selector} .subtext`,
  },
];

export default {
  props: {
    prop: String,
    loading: {
      type: Boolean,
      default: false,
    },
    properties: Object,
    tagName: {
      default: 'button',
    },
    textProps: Object,
  },
};
</script>

<style lang="scss">
.baseButton {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  position: relative;
  @keyframes shine_txt {
    to {
      background-position: 200% center;
    }
  }
  @keyframes shine {
    10% {
      opacity: 0.5;
      top: -30%;
      left: -200%;
      transition-property: left, top, opacity;
      transition-duration: 0.7s, 0.7s, 0.15s;
      transition-timing-function: ease;
    }
    100% {
      opacity: 0;
      top: -30%;
      left: 100%;
      transition-property: left, top, opacity;
    }
  }

  &.shine {
    overflow: hidden;

    &:after {
      animation: shine 3000ms ease-in-out infinite;
      animation-fill-mode: forwards;
      content: '';
      position: absolute;
      top: -80%;
      left: -200%;
      width: 150%;
      height: 500%;
      opacity: 0;
      transform: rotate(-10deg);
      background: rgba(255, 255, 255, 0.13);
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0) 30%,
        rgba(255, 255, 255, 0.13) 77%,
        rgba(255, 255, 255, 0.5) 92%,
        rgba(255, 255, 255, 1) 92%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }

  // Rocking

  @keyframes rocking {
    0% {
      transform: rotate(0deg);
    }

    25% {
      transform: rotate(0deg);
    }

    50% {
      transform: rotate(2deg);
    }

    75% {
      transform: rotate(-2deg);
    }

    100% {
      transform: rotate(0deg);
    }
  }

  &.rocking {
    animation: rocking 2s infinite;
    animation-duration: 2s;
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
    animation-delay: 0s;
    animation-iteration-count: infinite;
    animation-direction: normal;
    animation-fill-mode: none;
    animation-play-state: running;
    animation-name: rocking;
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
    transition: 0.2s;

    &:hover {
      animation: none !important;
    }
  }
}

.baseButton.s {
  padding: 0.5em 1em;
}

.baseButton.s .text {
  font-size: 1em;
}

.baseButton.m {
  padding: 1em 1.2em;
}

.baseButton.m .text {
  font-size: 1.2em;
}

.baseButton.l {
  padding: 1.8em 2em;
}

.baseButton.l .text {
  font-size: 1.8em;
}

.baseButton.fullwidth {
  width: 100%;
}

/* Loader logic */

.baseButton {
  .text,
  .subtext {
    opacity: 1;
    transition: opacity 200ms;
  }

  &:before {
    opacity: 0;
    transition: 150ms;
  }

  &.loader {
    opacity: 0.8;

    .text,
    .subtext {
      opacity: 0;
    }
  }
}
</style>
